// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3g7_v","bigColWidth":"Table_bigColWidth__3o9qL","biggerColWidth":"Table_biggerColWidth__o8_B9","row":"Table_row__shKSp","col":"Table_col__2lHJN"};